import http from '@/libs/AxiosPlugin.js'

const people = {
  list () {
    return http.get('/people/list')
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, username: 'admin', name: 'DaviaLi', sex: 1, workType: [1, 2], workNo: '123456', role: 'admin', phone: '12345678901', qq: '12345678', wechat: 'xxxxx', entryTime: '2017-01-01'}
    //   ]
    //   resolve(data)
    // })
  },

  get (id) {
    return http.post('/people/get', {id})
    // return Promise.resolve({id: 1, username: 'admin', name: 'DaviaLi', sex: 1, workType: [1, 2], workNo: '123456', role: 'admin', phone: '12345678901', qq: '12345678', wechat: 'xxxxx', entryTime: '2017-01-01'})
  },

  save (p) {
    return http.post('/people/save', p)
  }
}

export default people



// WEBPACK FOOTER //
// ./src/api/people.js